import React from 'react';
import PropTypes from 'prop-types';
import Image from 'gatsby-image';
import Logos from '../../../logos';
import styles from './home-projects-col.module.css';
import ReactFitText from 'react-fittext';
import Reveal from '../../../reveal';
import RevealSlideDown from '../../../animations/reveal-slide-down';
import Link from 'gatsby-link';
import { css } from 'emotion';

const ProjectsCol = props => {
  const { projects } = props;
  return projects.map((project, index) => {
    return (
      <Reveal key={index}>
        <RevealSlideDown isInView={props.isInView} delay={200}>
          <ProjectColCard project={project} index={index} />
        </RevealSlideDown>
      </Reveal>
    );
  });
};

const ProjectColCard = props => {
  const { acf, slug } = props.project.node;
  const { index, animation } = props;
  return (
    <div
      className={[styles.project, index === 0 ? styles.first : null].join(' ')}
      style={animation}
    >
      <Link className={styles.projectImage} to={`our-work/${slug}`}>
        <div className={styles.logo}>
          <Logos slug={slug} />
        </div>
        <Image
          className={styles.image}
          outerWrapperClassName={styles.imageOuterWrapper}
          sizes={acf.home_image.localFile.childImageSharp.sizes}
          backgroundColor={true}
          alt={'Culture'}
        />
      </Link>

      <div className={styles.info}>
        <ReactFitText compressor={0.95} maxFontSize={40}>
          <h3 className={styles.headline}>{acf.headline}</h3>
        </ReactFitText>
        <ReactFitText compressor={1.75} maxFontSize={20}>
          <p className={styles.description}>{acf.home_description}</p>
        </ReactFitText>
      </div>
    </div>
  );
};

ProjectColCard.propTypes = {
  project: PropTypes.object.isRequired,
};

export default ProjectsCol;



// WEBPACK FOOTER //
// ./src/components/home/home-projects/home-projects-col/index.js